import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../components/usuarios_tienda/Sidebar";
import { useEffect, useState } from "react";
import { meUsuarioTienda } from "../services/LoginUserTienda";

function AdminLayout() {
  const navigate = useNavigate();

  const [open, setOpen] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenWidth(width);
      setOpen(width >= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("usuario_token");

    if (!token) {
      navigate("/administrator/admin/login");
      return;
    }

    let mounted = true;

    (async () => {
      try {
        const me = await meUsuarioTienda();

        if (!mounted) return;

        localStorage.setItem("permisos", JSON.stringify(me.permisos || []));
        localStorage.setItem("usuario_id", String(me.usuario_id || ""));
      } catch (e) {
        localStorage.removeItem("usuario_token");
        localStorage.removeItem("usuario");
        localStorage.removeItem("usuario_id");
        localStorage.removeItem("permisos");

        navigate("/administrator/admin/login");
        return;
      } finally {
        if (mounted) setBooting(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  if (booting) return null;

  const isMobile = screenWidth < 768;
  const sidebarWidth = open ? (collapsed ? "78px" : "270px") : "0px";

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        position: "relative",
        background: `
          radial-gradient(circle at top left, rgba(37, 99, 235, 0.16), transparent 28%),
          radial-gradient(circle at bottom right, rgba(14, 165, 233, 0.12), transparent 24%),
          linear-gradient(180deg, #0B1220 0%, #0F172A 48%, #020617 100%)
        `,
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px)
          `,
          backgroundSize: "34px 34px",
          opacity: 0.5,
          pointerEvents: "none",
        }}
      />

      {isMobile && open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(2, 6, 23, 0.58)",
            backdropFilter: "blur(4px)",
            zIndex: 3000,
          }}
        />
      )}

      <div
        style={{
          width: sidebarWidth,
          height: "100vh",
          position: isMobile ? "fixed" : "relative",
          top: 0,
          left: 0,
          overflow: "hidden",
          zIndex: 3001,
          transition: "width 0.25s ease",
          flexShrink: 0,
          borderRight: open ? "1px solid rgba(148, 163, 184, 0.10)" : "none",
          boxShadow: open ? "10px 0 35px rgba(0,0,0,0.22)" : "none",
        }}
      >
        <Sidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          open={open}
          setOpen={setOpen}
          isMobile={isMobile}
        />
      </div>

      <div
        style={{
          flex: 1,
          height: "100vh",
          overflowY: "auto",
          padding: isMobile ? "14px" : "22px",
          display: "flex",
          justifyContent: "center",
          position: "relative",
          zIndex: 1,
          marginLeft: !isMobile ? "0px" : 0,
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "1600px",
            minHeight: "calc(100vh - 44px)",
            background: "rgba(15, 23, 42, 0.74)",
            backdropFilter: "blur(18px)",
            WebkitBackdropFilter: "blur(18px)",
            borderRadius: "24px",
            padding: isMobile ? "16px" : "22px",
            border: "1px solid rgba(148, 163, 184, 0.14)",
            boxShadow:
              "0 25px 70px rgba(0,0,0,0.32), inset 0 1px 0 rgba(255,255,255,0.03)",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "3px",
              background: "linear-gradient(90deg, #2563EB, #0EA5E9)",
              opacity: 0.95,
            }}
          />

          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;